import { isMskWide } from '@search/helpers/src/isRegion';

import { DeveloperWithPromoName } from './types';

export const getDeveloperPromoName = (regionId?: number): DeveloperWithPromoName | undefined => {
    if (regionId) {
        if (isMskWide(regionId)) {
            return 'samolet';
        }
    }

    return;
};
